<template>
  <div>

    <data-table
      table-ref="utilrpttable"

      :title="utilLabel + ' Bill Report'"
      icon="fa fa-plug"

      url="/report/utility/summary"
      :fields="fields"

      sort-field="siteName"

      :show-refresh="false"
      :show-search="false"

      detail-component="util-report-detail" />

  </div>
</template>

<script>

import Vue from 'vue'

import {settings} from '@/components/Data'

import UtilityReportDetails from '@/components/dashboard/utility/UtilityReportDetails'

Vue.component('util-report-detail', UtilityReportDetails)

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

export default {
  mixins: [DateMixins, NumberMixins, PostMixins],

  data () {
    return {
      format: settings.selectDateFormat,
      currency: settings.currency,
      utilLabel: this.getUtilLabel(),
      taxLabel: settings.taxName,
      amountLabel: settings.utilAmountLabel,
      extraChargesLabel: settings.utilExtraInputLabel,
      extraCalcTotal: settings.utilExtraInputTotal,
      site: {sharers: []},
      rates: [],
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'period',
          title: 'Period'
        },
        {
          name: 'siteId',
          title: 'Site ID',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'siteName',
          title: 'Site Name'
        },
        {
          name: 'sharers',
          title: 'Site Sharers',
          dataClass: 'text-bold text-center',
          callback: this.formatInteger
        },
        {
          name: 'penalties',
          title: 'Penalties',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-muted',
          callback: this.formatNumber
        },
        {
          name: 'amount',
          title: 'Amount',
          dataClass: 'text-bold text-right',
          callback: this.formatNumber
        },
        {
          name: 'extraCharges',
          title: settings.utilExtraInputLabel,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-muted text-right',
          callback: this.formatNumber
        },
        {
          name: 'tax',
          title: settings.taxName,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down text-muted text-right',
          callback: this.formatNumber
        },
        {
          name: 'extraCharges',
          title: 'Non-Tax',
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-muted text-right',
          callback: this.formatNumber
        },
        {
          name: 'total',
          title: 'TOTAL',
          dataClass: 'text-primary text-bold text-right',
          callback: this.formatNumber
        },
        {
          name: 'totalBillsPeriod',
          title: 'Bills',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down text-center'
        },
        {
          name: 'paidBillsPeriod',
          title: 'Paid',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down text-center'
        },
        {
          name: 'totalPaid',
          title: 'Total Paid',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down text-success pull-right',
          callback: this.formatNumber
        },
        {
          name: 'amountDue',
          title: 'Balance O/S',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down text-warning pull-right',
          callback: this.formatNumber
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// UtilityReport.vue?4f970caf